module.exports = __webpack_public_path__ + "img/restwertkalkulator.585119da.png";